import Users from '@/api/users.js'

export default {
  methods: {
    addFavorite (type, id) {
      const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1, -1)
      let favorite = {}
      favorite[type.slice(0, -1)] = id

      Users[`addFavorite${capitalizedType}`](favorite, false)
        .then(() => this.$store.dispatch('authent/addFavorite', { type, id }))
        .catch(error => { this.flashError(error.response.data) })
    },
    removeFavorite (type, id) {
      const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1, -1)
      Users[`removeFavorite${capitalizedType}`](id, false)
        .then(() => {
          this.$emit('favorite-removed')
          this.$store.dispatch('authent/removeFavorite', { type, id })
        })
        .catch(error => { this.flashError(error.response.data) })
    },
    updateLastSeen (type, id) {
      Users[`seenFavorite${type}`](id, false)
        .catch(() => {})
    }
  }
}
